import styled from 'styled-components';
import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { useLocation, useHistory } from 'react-router-dom';
import { MenuToggle } from '../../nav/menu.toggle';
import { Navigation } from '../../nav/menu.navigation';
import { AlertIcon, BackArrowIcon } from '../../icon/icon';
import { fetchNotificationComfirm } from '../../../api/alert';

const sidebarVariants = {
  open: {
    x: 0,
    transition: {
      type: 'spring',
      stiffness: 400,
      damping: 40,
    },
  },
  closed: {
    x: '100%',
    transition: {
      type: 'spring',
      stiffness: 400,
      damping: 40,
    },
  },
};

interface UserHeaderProps {
  menuTitle: string;
  showBackArrow?: boolean;
}

interface LocationState {
  selectedType?: string;
  borderLine?: boolean;
}

interface FetchNotificationResponse {
  orderId: number;
  obtainId: number;
  name: string;
  content: string;
  createdAt: string;
  vehicle?: string;
}

const UserHeader = ({ menuTitle, showBackArrow }: UserHeaderProps) => {
  const location = useLocation<LocationState>();
  const history = useHistory();
  const [alertState, setAlertState] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const { selectedType, borderLine = false } = location.state || {};

  const handleAlertClick = () => {
    history.push('/common/alert');
  };

  const handleBackClick = () => {
    history.goBack();
  };

  useEffect(() => {
    const getNotificationComfirm = async () => {
      try {
        const response = await fetchNotificationComfirm();
        setAlertState(!response);
      } catch (error) {
        console.error(error);
      }
    };

    getNotificationComfirm();
  }, []);

  useEffect(() => {
    const getNotificationComfirm = async () => {
      try {
        const response = await fetchNotificationComfirm();
        setAlertState(!response);
      } catch (error) {
        console.error(error);
      }
    };

    // 경로가 '/common/alert'에 도착했을 때 호출
    if (location.pathname === '/common/alert') {
      getNotificationComfirm();
    }
  }, [location.pathname]); // 경로가 변경될 때마다 실행

  return (
    <HeaderContainer alertState={alertState} borderLine={borderLine}>
      <div className="title">
        {showBackArrow && (
          <div className="icon-box" onClick={handleBackClick}>
            <BackArrowIcon />
          </div>
        )}
        <SpanWrapper showBackArrow={showBackArrow}>
          {menuTitle}{' '}
          {selectedType
            ? selectedType === 'belonged'
              ? '일대차'
              : '마당차'
            : null}
        </SpanWrapper>
      </div>
      {!showBackArrow ? (
        <div className="subject">
          <div className="icon-box" onClick={handleAlertClick}>
            <AlertIcon />
          </div>
          <motion.nav initial={false} animate={isOpen ? 'open' : 'closed'}>
            <MenuToggle toggle={() => setIsOpen(!isOpen)} />
            <motion.div
              variants={sidebarVariants}
              style={{
                backgroundColor: '#FFF',
                position: 'fixed',
                width: '100%',
                height: '100%',
                zIndex: 100,
                top: 0,
                left: 0,
              }}
            >
              {isOpen && <Navigation setIsOpen={setIsOpen} />}
            </motion.div>
          </motion.nav>
        </div>
      ) : null}
    </HeaderContainer>
  );
};

export default UserHeader;

//style
const HeaderContainer = styled.header<{
  alertState: boolean;
  borderLine: boolean;
}>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  padding: 1.1rem 1.4rem;
  border-bottom: ${(props) =>
    props.borderLine ? '1px solid #F0F0F0' : 'none'};
  .title {
    font-size: 2.2rem;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 1.2rem;
    color: ${(props) => props.theme.textBlackColor};
    /* transform: translate(-0.7rem); */
    .icon-box {
      display: flex;
    }
    span {
      transform: translateY(1px);
    }
  }
  .subject {
    display: flex;
    align-items: center;
  }
  nav {
    width: 3.2rem;
    height: 3.2rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    padding: 0.8rem 0.7rem;
    span {
      display: flex;
      width: 1.8rem;
      height: 2rem;
      background-color: ${(props) => props.theme.menuNavColor};
    }
  }
  .icon-box {
    display: flex;
    svg {
      .nev-alert {
        fill: ${(props) => (props.alertState ? '#FF5151' : 'transparent')};
      }
    }
  }
`;

const SpanWrapper = styled.span<{ showBackArrow?: boolean }>`
  ${({ showBackArrow }) =>
    showBackArrow &&
    `
    font-size: 1.6rem;
    font-weight: 600;
    position: absolute;
    top: 1.9rem;
    left: 50%;
    transform: translateX(-50%) !important;
  `}
`;
